import { ClinicianService } from "@/common/api.service";
import { FETCH_CLINICIAN_DATA, FETCH_CLINICIAN_PATIENT_DATA, FETCH_KIOSK_MODE_DATA, PATIENT_FOLLOW ,PATIENT_SEND_FITBIT_LINK, FETCH_INDIVIDUAL_CLINICIAN_DATA, UPDATE_CLINICIAN_DATA ,CREATE_CLINICIAN_DATA, SAVE_USER_PREFERENCES, FETCH_CHARTS_DATA, RESET_STATE } from "./actions.type";
import { SET_CLINICIAN_DATA, SET_CLINICIAN_PATIENT_DATA, SET_INDIVIDUAL_CLINICIAN_DATA, SET_CLINICIAN_ERROR, SET_CHARTS_DATA, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    cliniciandata: [],
    individualcliniciandata: [],
    clinicianerror: [],
    chartsdata: [],
    clinicianpatientdata:[]
  }
};

export const state = initialState();

const actions = {

  async [FETCH_CLINICIAN_DATA](context, slug) {
    return await ClinicianService.get(slug).then(({data}) => {
      context.commit(SET_CLINICIAN_DATA, data)
      return data
    }).catch((response) =>{
      context.commit(SET_CLINICIAN_ERROR, (typeof response == Object? response.data.errorMessage : response))
      return response
    })
  },

  async [FETCH_CLINICIAN_PATIENT_DATA](context, slug) {
    return await ClinicianService.get(slug).then(({data}) => {
      context.commit(SET_CLINICIAN_PATIENT_DATA, data)
      return data
    }).catch((response) =>{
      context.commit(SET_CLINICIAN_ERROR, (typeof response == Object? response.data.errorMessage : response))
      return response
    })
  },

  async [FETCH_INDIVIDUAL_CLINICIAN_DATA](context, slug) {
    return await ClinicianService.get(slug).then((response)=> {
      context.commit(SET_INDIVIDUAL_CLINICIAN_DATA, response.data)
      return response
    }).catch(({response})=>{
      context.commit(SET_CLINICIAN_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [CREATE_CLINICIAN_DATA](context, slug) {
    return await ClinicianService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({response})=>{
      context.commit(SET_CLINICIAN_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [PATIENT_SEND_FITBIT_LINK](context, slug) {
    return await ClinicianService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({response})=>{
      context.commit(SET_CLINICIAN_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [PATIENT_FOLLOW](context, slug) {
    return await ClinicianService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({response})=>{
      context.commit(SET_CLINICIAN_ERROR, response.data.errorMessage)
      return response
    })
  },  

  async [FETCH_KIOSK_MODE_DATA](context, slug) {
    return await ClinicianService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({response})=>{
      context.commit(SET_CLINICIAN_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [UPDATE_CLINICIAN_DATA](context, slug) {
    return await ClinicianService.update(slug).then(({ data }) => {
      return data
    }).catch(({response})=>{
      context.commit(SET_CLINICIAN_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [SAVE_USER_PREFERENCES](context, slug) {
    return await ClinicianService.update(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({ response})=>{
      context.commit(SET_PATIENT_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_CHARTS_DATA](context, slug) {
    return await ClinicianService.get(slug).then((response)=> {
      context.commit(SET_CHARTS_DATA, response.data)
      return response
    }).catch(({response})=>{
      context.commit(SET_CLINICIAN_ERROR, response.data.errorMessage)
      return response
    })
  }, 

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_CLINICIAN_DATA](state, cliniciandata) {
    state.cliniciandata = cliniciandata
  },
  [SET_CLINICIAN_PATIENT_DATA](state, clinicianpatientdata) {
    state.clinicianpatientdata = clinicianpatientdata
  },
  [SET_INDIVIDUAL_CLINICIAN_DATA](state, individualclinician) {
    state.individualcliniciandata = individualclinician
  },
  [SET_CHARTS_DATA](state, chartsdata) {
    state.chartsdata = chartsdata
  },
  [SET_CLINICIAN_ERROR](state, error) {
    state.clinicianerror = error
  },  
  [STATE_RESET](state) {
    Object.assign(state,initialState())
  }

}

const getters = {
  cliniciandata(state) {
    return state.cliniciandata;
  },
  individualcliniciandata(state) {
    return state.individualcliniciandata;
  },
  chartsdata(state) {
    return state.chartsdata;
  },
  clinicianpatientdata(state) {
    return state.clinicianpatientdata;
  }

}

export default {
    state,
    getters,
    actions,
    mutations
};